import React, { useEffect, useState } from "react";

import { handleCheckColumnFornecedor, handleHomologacao } from "../GridCell/Fornecedor"
import ResponsiveDataTable from "../DataTable";

const SelecaoFornecedores = (DisparaBootBox, FechaBox, dataFornecedor) => {
    const columns = [
        { Header: 'Codigo',     accessor: "A2_COD" },
        { Header: 'Loja',       accessor: "A2_LOJA" },
        { Header: 'Nome',       accessor: 'A2_NOME' },
        { Header: 'CNPJ',       accessor: 'A2_CGC' },
        { Header: 'Municipio',  accessor: 'A2_MUN' },
        { Header: 'Estado',     accessor: 'A2_EST' },
        { Header: 'Homologado', accessor: 'A2_XHOMOL', Cell: handleHomologacao }
    ];

    const Mensagem = (
        <ResponsiveDataTable
            columns={columns}
            data={dataFornecedor} // Carregar dados conforme necessário
            buttons={[]}
            isIgnorar={true}
            habilitaCheckBox={true}
        />
    );

    const buttonsRender = [
        { variant: 'primary', action: FechaBox, label: 'Aplicar' }
    ];

    DisparaBootBox('Selecione o(s) Fornecedor(es)', Mensagem, buttonsRender, 0, FechaBox, 'xl', false, true, true);
};

export default SelecaoFornecedores;